import { useEffect } from "react";
import { Icon } from "@iconify/react";

const TiendaLTE = ({ show, onClose }) => {
  useEffect(() => {
    const handleEscKey = (event) => {
      if (event.key === "Escape" && show) {
        onClose();
      }
    };

    if (show) {
      document.body.style.overflow = "hidden";
      document.addEventListener("keydown", handleEscKey);
    } else {
      document.body.style.overflow = "";
      document.removeEventListener("keydown", handleEscKey);
    }

    return () => {
      document.body.style.overflow = "";
      document.removeEventListener("keydown", handleEscKey);
    };
  }, [show, onClose]);

  if (!show) return null;

  return (
    <div
      className="fixed inset-0 z-30 px-4 bg-zinc-950 bg-opacity-50 flex items-center justify-center transition-opacity"
      onClick={onClose}
    >
      <div
        className="min-w-[374px] w-[374px] sm:w-[629px] md:w-[759px] lg:w-[1014px] xl:w-[1269px] bg-zinc-900 border border-zinc-700 rounded-2xl p-6 shadow-lg relative opacity-100 transform scale-100 transition-all duration-300"
        onClick={(e) => {
          e.stopPropagation();
        }}
        role="button"
        tabIndex="0"
      >
        <button
          className="bg-neutral-800 hover:bg-neutral-700 text-gray-400 hover:text-gray-200 p-[7px] rounded-lg absolute top-3.5 right-3.5"
          onClick={onClose}
        >
          <Icon icon="ic:round-close" className="text-lg" />
        </button>
        <h3 className="text-xl sm:text-2xl font-bold">TiendaLTE</h3>
        <h4 className="text-sm sm:text-base font-semibold">
          Plataforma E-commerce para Gestión Eficiente de Ventas Online.
        </h4>
        <p className="text-sm sm:text-base font-light">
          Una plataforma E-commerce diseñada para facilitar el comercio
          electrónico, estructurada con Laravel para el backend y utilizando
          Tailwind CSS para la vista de clientes, asegurando un diseño moderno y
          eficiente. Para la vista administrativa destinada a vendedores, se
          emplea Bootstrap integrado con AdminLTE, proporcionando un panel de
          administración robusto y fácil de usar. Además, se incluyen
          funcionalidades avanzadas como autenticación y gestión de sesiones con
          Laravel Jetstream, interactividad en tiempo real mediante Livewire, y
          gestión eficiente de dependencias con Composer. La plataforma también
          incorpora tecnologías como jQuery, stringToSlug para URLs optimizadas,
          SweetAlert2 para notificaciones personalizadas, y DataTables para la
          visualización eficaz de datos tabulares, garantizando un rendimiento
          óptimo y escalabilidad en la gestión de productos y experiencia de
          compra.
        </p>
        <div className="flex items-center gap-1">
          <Icon className="w-10 h-10" icon="devicon:php"></Icon>
          <Icon className="w-10 h-10" icon="logos:laravel"></Icon>
          <Icon className="w-10 h-10" icon="logos:tailwindcss-icon"></Icon>
          <Icon className="w-10 h-10" icon="logos:bootstrap"></Icon>
          <Icon className="w-10 h-10" icon="devicon:livewire"></Icon>
          <Icon className="w-10 h-10" icon="logos:composer"></Icon>
          <Icon className="w-10 h-10" icon="devicon:jquery"></Icon>
        </div>
      </div>
    </div>
  );
};

export default TiendaLTE;
